import { zoomIn } from "react-animations";
import styled, { keyframes } from "styled-components";

const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 2s ${zoomAnimation};
  width: 60%;
  background-color: rgba(0, 0, 0, 0.8);
  margin: 11% auto;
  color: white;
  font-family: "Comic Neue", cursive;
  font-weight: bold;
  border-radius: 20px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 0 5px 5px #b026ff;
  display: flex;

  & > :nth-child(2) {
    width: 60%;
  }
  & > :nth-child(2) > h1 {
    margin-bottom: 2.5%;
    padding-bottom: 10px;
    border-bottom: 4px solid #b026ff;
  }
  & > :nth-child(2) > p {
    line-height: 20px;
    text-align: justify;
  }
  & > :nth-child(1) {
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: center;
  }
  & > :nth-child(1) > img {
    width: 80%;
  }

  @media screen and (max-width: 768px) {
    width: 88%;
    background-color: rgba(0, 0, 0, 0.8);
    margin: 5% auto;
    color: white;
    font-family: "Comic Neue", cursive;
    font-weight: bold;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
    box-shadow: 0 0 5px 5px #b026ff;
    display: flex;
    flex-direction: column-reverse;
    & > :nth-child(2) {
      width: 100%;
    }
    & > :nth-child(2) > h1 {
      margin-bottom: 2%;
      padding-bottom: 10px;
      border-bottom: 4px solid #b026ff;
    }
    & > :nth-child(1) {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
    }
    & > :nth-child(1) > img {
      width: 80%;
      margin-top: 5%;
      margin-bottom: 5%;
    }
  }
`;

export const About = () => {
  return (
    <ZoomDiv>
      <div>
        <img
          src="https://media4.giphy.com/media/VTtANKl0beDFQRLDTh/giphy.gif?cid=ecf05e47z4j9rpc851ikpxtsviys310y4jzyxp7svs6rjr8s&rid=giphy.gif&ct=g"
          alt="gif"
        />
      </div>
      <div>
        <h1>About Me</h1>
        <p>
          Being effective and motivated towards the work that I do happens to be
          my utmost priority. Out of my interest and love for machines, I opted
          for Mechanical Engineering as my major in graduation after which I
          landed a technically sound and interesting position as a Process
          Design Engineer in a well-known automotive firm. During my working
          period there, I happen to deliver quite a few important projects that
          taught me the true meaning of effectiveness. Out of my inclination
          towards this fast-growing world of tech, I decided to pursue Full
          Stack Web Development as a specialization. Working with MERN stack and
          programming languages like JavaScript catalyzed my curiosity for web
          development. I have worked in collaborative environments demonstrating
          my coding skills to meet deadlines. If you want to know more about me
          feel free to connect with me. Start by visiting the contact tab.
        </p>
      </div>
    </ZoomDiv>
  );
};
